module.exports = __webpack_public_path__ + "static/Joy@2x.30143b4b.png";